var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNwmlsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.05 126.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#678849;}.cls-3{fill:#8ca574;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol___tm"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.03,126.05C28.27,126.05,0,97.78,0,63.03S28.27,0,63.03,0s63.03,28.27,63.03,63.03-28.27,63.03-63.03,63.03Zm0-122.3C30.34,3.75,3.75,30.34,3.75,63.03s26.59,59.28,59.28,59.28,59.28-26.59,59.28-59.28S95.71,3.75,63.03,3.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 63.03,
    cy: 63.03,
    r: 59.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Three_Trees",
    className: "cls-1",
    d: "M104.59,48.79l-7.25-15.73c-.35-.75-1.13-1.23-1.99-1.23h0c-.87,0-1.65,.48-1.99,1.23l-20.89,45.5v-6.32h-9.74l7.64-12.83v-10.46h4.59v5.17l4.9-5.32-7.25-15.73c-.35-.75-1.13-1.23-1.99-1.23h0c-.87,0-1.65,.48-1.99,1.23l-20.88,45.5v-6.32h-9.74l7.64-12.83v-10.46h4.59v5.17l4.9-5.32-7.26-15.73c-.34-.75-1.12-1.23-1.99-1.23h0c-.87,0-1.65,.48-1.99,1.23l-22.23,48.44c-.29,.63-.22,1.35,.18,1.93,.4,.57,1.09,.91,1.81,.91h17.28v9.87h6.53v-9.87h18.2v9.87h6.53v-9.87h18.2v9.87h6.58v-21.98h-9.51l7.64-12.83v-10.46h4.6v5.17l4.89-5.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "trademark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.19,110.62c2.14,0,3.89,1.74,3.89,3.88s-1.74,3.89-3.89,3.89-3.88-1.74-3.88-3.89,1.74-3.88,3.88-3.88Zm0,7.08c1.77,0,3.2-1.43,3.2-3.2s-1.43-3.19-3.2-3.19-3.19,1.43-3.19,3.19,1.43,3.2,3.19,3.2Zm-1.49-5.44h1.71c1.07,0,1.56,.48,1.56,1.34,0,.77-.46,1.15-1.06,1.22l1.16,1.88h-.86l-1.11-1.82h-.59v1.82h-.82v-4.44Zm.82,1.93h.59c.5,0,1.05-.03,1.05-.63s-.55-.63-1.05-.61h-.59v1.24Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNwmlsLogo);
export default __webpack_public_path__ + "static/media/nwmls-logo.2e328f06cd57f8716e39b52669f712a8.svg";
export { ForwardRef as ReactComponent };